/**
 *
 * @Copyright 2025 UNLOCKIT DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */

import React, { FunctionComponent } from 'react';
import { TranslationContext, withTranslationContext } from './TranslationContext';

import { useCornerstoneApi } from '../../api';
import { UserContext, UserContextProvider } from './UserContext';
import {
    userByEmailUrl,
    userInvitesUrl,
} from '../../services/users';
import { ErrorResponse } from '../../types/errors';
import { KeyedObject } from '../../types/general';
 
interface OwnProps {
    children: React.ReactNode;
}

type Props = OwnProps & TranslationContext;

const UserController: FunctionComponent<Props> = (props: Props) => {
    const { children } = props;
    const CornerstoneApiInstance = useCornerstoneApi();

    const getUserByEmail: UserContext['getUserByEmail'] = async (email: string) => {
        try {
            const response = await CornerstoneApiInstance.get(userByEmailUrl(email));
            
            return [response, null];
        } catch (e) {
            return [null, e as ErrorResponse];
        }
    };
    const getUserPendingInvites: UserContext['getUserPendingInvites'] = async (params: KeyedObject<string>) => {
        try {
            const { data } = await CornerstoneApiInstance.get(userInvitesUrl(params));
            return data;
        } catch {
            return {
                cursor: '',
                results: [],
            };
        }
    };

    return (
        <UserContextProvider
            value={{
                getUserByEmail,
                getUserPendingInvites,
            }}
        >
            {children}
        </UserContextProvider>
    );
};

export default withTranslationContext(UserController);
